import { withFormik } from 'formik'
import _ from 'lodash'
import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../Components/Button'
import Field from '../../../Components/Formik/Field'
import Form from '../../../Components/Formik/Form'
import { FINNACIAL_REPORT, STATUS } from '../../../Util/Options'
import { GET_DATA, SET_DATA, validateAccess } from '../../../Util/Util'

function Filter(props) {
  const history = useHistory()

  const onSubmitForm = async () => {
    props.validateForm().then((err) => {
      if (_.isEmpty(err)) {
        props.onFilter(_(props.values).omitBy(_.isEmpty).value())
        SET_DATA('accountGroups.filterData', props.values)
      }
    })
  }

  const onClear = () => {
    props.resetForm({})
    props.onFilter({})
  }

  return (
    <div className="filter-section">
      {validateAccess('add-account-group') && (
        <Button
          onClick={() => history.push('/app/add-account-group')}
          variant="primary"
          className="btn-block">
          <i className="flaticon-plus" /> Add Account Group
        </Button>
      )}
      <Form>
        <div className="form-fields">
          <Field name="rangeStart" label="Range Start" />
        </div>
        <div className="form-fields">
          <Field name="rangeEnd" label="Range End" />
        </div>
        <div className="form-fields">
          <Field name="name" label="Name" />
        </div>
        <div className="form-fields">
          <Field name="financialReport" label="Financial Report" as="select" options={FINNACIAL_REPORT} />
        </div>
        <div className="form-fields">
          <Field name="status" label="Status" as="select" options={STATUS} />
        </div>
        <div className="form-fields">
          <Button variant="secondary" className="search" onClick={onSubmitForm}>
            <i className="flaticon-search-interface-symbol" />
            Search
          </Button>
          <Button className="btn-block btn-glow search" onClick={onClear}>
            Clear
          </Button>
        </div>
      </Form>
    </div>
  )
}

export default withFormik({
  mapPropsToValues: () => {
    const filterObj = GET_DATA('accountGroups.filterData')

    return {
      rangeStart: filterObj?.rangeStart || '',
      rangeEnd: filterObj?.rangeEnd || '',
      accountType: filterObj?.accountType || '',
      financialReport: filterObj?.financialReport || '',
      status: filterObj?.status || ''
    }
  },
  handleSubmit: () => null
})(Filter)
